import * as Sentry from "@sentry/react";

Sentry.init({
  enabled: import.meta.env.VITE_STAGE !== "development",
  dsn: import.meta.env.VITE_SUPPORT_SENTRY_DSN as string,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.extraErrorDataIntegration(),
  ],

  environment: import.meta.env.VITE_STAGE as string,

  release:
    import.meta.env.VITE_STAGE === "production"
      ? `support-new@${import.meta.env.VITE_VERSION}`
      : `support-new@${import.meta.env.VITE_STAGE}.${import.meta.env.VITE_COMMIT_SHA}`,
});
